import {
  GetDocumentSettingsResponseDto,
  InformationForContentDeclarationResponseDto,
  InformationForDocumentResponseDto,
} from '@tiendanube/common';
import { DocumentType } from 'domains/FulfillmentOrders/pages/PrintDocumentPage/constants';
import DocumentPreview from '../DocumentPreview';

interface BoxLabelDocumentPreviewProps {
  information?:
    | InformationForContentDeclarationResponseDto[]
    | InformationForDocumentResponseDto[];
  isLoading: boolean;
  settings: GetDocumentSettingsResponseDto;
  locationId: string;
  hasOca: boolean;
}

function BoxLabelDocumentPreview({
  information,
  isLoading,
  settings,
  locationId,
  hasOca,
}: Readonly<BoxLabelDocumentPreviewProps>) {
  const alignItems = isLoading ? 'center' : 'flex-start';

  return (
    <div
      id={`print-container-${DocumentType.LABEL}`}
      className={hasOca ? 'oca-with-enhanced' : ''}
      style={
        information?.length && information.length <= 2
          ? {
              display: 'grid',
              gridTemplateColumns: information.length === 1 ? '1fr' : '1fr 1fr',
              columnGap: '0',
              width: information.length === 1 ? '50%' : '100%',
              alignItems: alignItems,
              justifyContent: 'center',
              paddingLeft: '2%',
            }
          : {
              width: '100%',
              justifyContent: 'center',
              alignItems: alignItems,
              columns: 2,
              columnGap: '0',
              padding: '2%',
            }
      }
    >
      {!isLoading && information && (
        <DocumentPreview
          type={DocumentType.LABEL}
          information={information as InformationForDocumentResponseDto[]}
          settings={settings}
          locationId={locationId}
          hasOca={hasOca}
        />
      )}
    </div>
  );
}

export default BoxLabelDocumentPreview;
